import React, { useContext } from 'react';
import RequestContext from '../../../fgs/context/RequestContext';

const NOT_FOUND = 'URL de Instrumentação não encontrada para o usuário';

export const InstrumentationPage = () => {
  const requestContext = useContext(RequestContext);
  const loggedUser = requestContext.loggedUser;

  if (loggedUser) {
    const url = loggedUser.instrumentationUrl;

    return url 
      ? <iframe className="resources-iframe" src={url} /> 
      : <span>{NOT_FOUND}</span>;
  }

  return (
    <span>{NOT_FOUND}</span>
  );
};